/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterView } from "vue-router";
import { AgentSidebar } from "./components/AgentSidebar";
import { setTitle } from "@lemmonhq/orders";

export { AgentDirectory } from "./subpages/AgentDirectory";
export { ThreadView } from "./subpages/ThreadView";
export { ProjectSettings } from "./subpages/ProjectSettings";

export const IntelligencePage = defineComponent({
  name: "IntelligencePage",
  setup() {
    setTitle("Intelligence");
    return () => (
      <div class="flex h-full flex-row overflow-hidden ">
        <AgentSidebar />
        <div class="flex flex-1 min-w-0 overflow-hidden">
          <RouterView />
        </div>
      </div>
    );
  },
});
